import PatientData from 'model/PatientData'
import WebRepository from '../web/WebRepository'
import Api from 'clients/web/Api'

export class PatientDataRepository extends WebRepository<PatientData> {
  constructor() {
    super(new Api('patients_data'))
  }

  async search(patientId: string): Promise<PatientData[]> {
    return super.search({
      selector: {
        $and: [
          {
            patientId: patientId,
          },
        ],
      },
    })
  }
}

export default new PatientDataRepository()
